export enum COMPLIANCE_TIER {
  IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
  ID_VERIFICATION_WITH_ACCREDITATION = 'ID_VERIFICATION_WITH_ACCREDITATION',
  NO_VERIFICATION = 'NO_VERIFICATION',
}
